module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('nav', {
    staticClass: "navigation-mobile",
    class: {
      "navigation-mobile--scrolled": _vm.$store.state.nav >= 1, "navigation-mobile--active": _vm.drawerActive, "navigation-mobile--page": _vm.$route.path != "/", "navigation-mobile--diff": _vm.$route.path.includes("/lucas")
    }
  }, [_c('div', {
    staticClass: "navigation-mobile__container"
  }, [_c('router-link', {
    staticClass: "navigation-mobile__home",
    attrs: {
      "to": "/"
    }
  }, [_c('Icon', {
    staticClass: "navigation-mobile__logo",
    attrs: {
      "name": "SimpleLogo"
    }
  })], 1), _c('div', {
    staticClass: "navigation-mobile__hamburger",
    on: {
      "click": _vm.openNav
    }
  }, [_c('span', {
    class: {
      active: _vm.drawerActive
    }
  }), _c('span', {
    class: {
      active: _vm.drawerActive
    }
  }), _c('span', {
    class: {
      active: _vm.drawerActive
    }
  }), _c('span', {
    class: {
      active: _vm.drawerActive
    }
  })])], 1), _c('transition', {
    attrs: {
      "name": "navigation-mobile__transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.drawerActive),
      expression: "drawerActive"
    }],
    staticClass: "navigation-mobile__drawer",
    on: {
      "click": _vm.openNav
    }
  }, [_vm._l((_vm.links), function(link, i) {
    return (link.navigation) ? _c('router-link', {
      key: i,
      staticClass: "navigation-mobile__link",
      class: {
        active: _vm.linksActive
      },
      style: ({
        transitionDelay: i * .05 + 's'
      }),
      attrs: {
        "to": link.path
      }
    }, [_vm._v(_vm._s(link.name))]) : _vm._e()
  }), _c('div', {
    staticClass: "navigation-mobile__buttons"
  }, [_c('a', {
    staticClass: "navigation-mobile__button",
    attrs: {
      "href": _vm.props.acf.nav.phone_href
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.nav.phone_number)
    }
  })]), _c('div', {
    staticClass: "navigation-mobile__social"
  }, _vm._l((_vm.props.acf.nav.social), function(item, i) {
    return _c('a', {
      staticClass: "navigation-mobile__social-button",
      attrs: {
        "href": item.href
      }
    }, [_c('Icon', {
      staticClass: "navigation-mobile__social-icon",
      attrs: {
        "name": item.icon
      }
    })], 1)
  }))], 2)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6440800e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/navigation/navigation-mobile/navigation-mobile.pug
// module id = 645
// module chunks = 1